export default function preventLinksInEditor(){
    // Block only links inside the block editor content canvas, not all links in the admin UI.
    const editorCanvasSelectors = [
        '.edit-post-visual-editor',
        '.block-editor-writing-flow',
        '.block-editor-block-list__layout',
        '.editor-styles-wrapper',
        '.wp-block',
    ].join(', ');

    const isInEditorCanvas = (element) => {
        if (!element || typeof element.closest !== 'function') {
            return false;
        }

        return !!element.closest(editorCanvasSelectors);
    };

    const maybeStopLinkNavigation = (event) => {
        const target = event.target;
        const anchor = target && typeof target.closest === 'function'
            ? target.closest('a[href], area[href]')
            : null;

        if (!anchor || !isInEditorCanvas(anchor)) {
            return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
    };

    const addGuardToDocument = (doc) => {
        if (!doc || doc.__northernEdgeLinkGuardBound) {
            return;
        }

        doc.__northernEdgeLinkGuardBound = true;
        doc.addEventListener('click', maybeStopLinkNavigation, true);
        doc.addEventListener('auxclick', maybeStopLinkNavigation, true);
    };

    addGuardToDocument(document);

    document.querySelectorAll('iframe').forEach((frame) => {
        const frameDoc = frame.contentDocument || frame.contentWindow?.document;
        addGuardToDocument(frameDoc);
    });
}